<template>
  <div>
    <div id="myCal">
      <!-- 保费试算 -->
      <div class="title_">
        <div class="cutleft_ order">保费试算</div>
        <div class="cutleft_ policy">险种信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row class="changeStyle_">
        <a-col :span="18">
          <div class="form_item policy_none" style="justify-content: flex-start;">
            <label>保障期间</label>
            <div class="pre-box">
              <div class="">
                <a-radio-group v-model="guapre" :disabled="disabledAll"
                  @change="e => changeData(e.target.value, 'BZQJa')">
                  <a-radio v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
                </a-radio-group>
              </div>
            </div>
          </div>
          <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>

          <div class="form_item policy_none" style="justify-content: flex-start;">
            <label>投保职业</label>
            <div class="right_">
              <div class="check_item s_input" v-for="item in occupationNumberList" :key="item.occupationKind">
                <label for>
                  {{ item.occupationKind }}
                </label>
                <a-input-number :disabled="disabledAll" :min="0" v-model="item.personNum"
                  @change="value => changeData(value, 'TBZYa')"></a-input-number>
                <span>人</span>
              </div>

              <div class="check_item">
                <span>总人数：{{ totalNumber }}人</span>
              </div>
            </div>
          </div>
          <!-- <div class="form_items" style="justify-content: flex-start;">
            <label>是否涉高&nbsp;&nbsp;&nbsp;</label>
            <div class="right_">
              <div class="check_item">
                <a-radio-group name="radioGroup" :disabled="disabledAll" :default-value="0" v-model="countData.SFSGa" @change="e => changeData(e.target.value, 'SFSGa')">
                  <a-radio :value="2">不涉高</a-radio>
                  <a-radio :value="1">涉高</a-radio>
                </a-radio-group>
              </div>
            </div>
          </div> -->
        </a-col>
        <a-col :offset="2" :span="4" class="calRight_ policy_none">
          <div class="calTxt_">保费合计</div>
          <div class="calmoney_">¥ {{ premiumSum }}</div>
        </a-col>
      </a-row>
    </div>
    <div class="risk_">
      <p style="
          width: 100%;
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 0;
        ">
        主险
      </p>
      <div class="form_item">
        <label>工伤或意外身故、残疾</label>
        <div class="right_">
          <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_"
            @change="value => changeData(value, 'SWCJ')" v-model="countData.SWCJ">
            <a-select-option v-for="item in SWCJOptions" :key="item.value + 'SWCJ'" :value="item.value">{{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <p style="
          width: 100%;
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 0;
        ">
        附加险
      </p>
      <div class="flex_">
        <div class="form_item">
          <label>工伤或意外医疗费用（社保范围内0元免赔100%赔付）</label>
          <div class="right_">
            <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_"
              v-model="countData.YLFY" @change="value => changeData(value, 'YLFY')">
              <a-select-option v-for="(item, index) in YLFYOptions" :key="item.value + 'YLFY' + index"
                :value="item.value" :disabled="item.disabled">{{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <!-- 扩展社保外医疗费用（0元免赔90%赔付）(即保司系统自费药)（含甲乙丙类自付和自费） -->
        <div class="form_item">
          <label>扩展社保外医疗费用（0元免赔90%赔付）</label>
          <div class="right_">
            <a-select placeholder="请选择" style="width: 300px" class="select_"
              :disabled="countData.YLFY === 0 || disabledAll" v-model="countData.ZFYF"
              @change="value => changeData(value, 'ZFYF')">
              <a-select-option v-for="(item, index) in ZFYFOptions" :key="item.value + 'ZFYF' + index"
                :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <!-- 意外住院津贴责任 -->
        <div class="form_item">
          <label>意外住院津贴</label>
          <div class="right_">
            <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_"
              v-model="countData.ZYJT" @change="value => changeData(value, 'ZYJT')">
              <a-select-option v-for="item in ZYJTOptions" :key="item.value + 'ZYJT'" :value="item.value">
                {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <!-- 误工费 -->
        <div class="form_item">
          <label>误工费</label>
          <div class="right_">
            <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_"
              v-model="countData.WGFY" @change="value => changeData(value, 'WGFY')">
              <a-select-option v-for="item in WGFYOptions" :key="item.value + 'WGFY'" :value="item.value">
                {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <!-- 一次性伤残就业补助金 -->
        <!-- <div class="form_item">
          <label>一次性伤残就业补助金</label>
          <div class="right_">
            <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_"
              v-model="countData.YCXSCa" @change="value => changeData(value, 'YCXSCa')">
              <a-select-option v-for="item in oneSCOptions" :key="item.value + 'YCXSCa'" :value="item.value">
                {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div> -->
        <!-- 生活护理费 -->
        <!-- <div class="form_item">
          <label>生活护理费</label>
          <div class="right_">
            <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_"
              v-model="countData.SHHLa" @change="value => changeData(value, 'SHHLa')">
              <a-select-option v-for="item in SHHLOptions" :key="item.value + 'SHHLa'" :value="item.value">
                {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div> -->
        <!-- 工伤定残高赔付标准 -->
        <div class="form_item">
          <label>工伤伤残赔付高标准</label>
          <div class="right_">
            <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_"
              v-model="countData.CJBL" @change="value => changeData(value, 'CJBL')">
              <a-select-option v-for="item in GSDCOptions" :key="item.value + 'CJBL'" :value="item.value">
                {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="form_item">
          <label>附加24小时扩展条款B</label>
          <div class="right_">
            <a-select placeholder="请选择" style="width: 300px" class="select_"
              :disabled="countData.YLFY === 0 || disabledAll" @change="value => changeData(value, 'XS')"
              :value="countData.XS == 0 ? 0 : 1">
              <a-select-option v-for="item in XSOptions" :key="item.value + 'XS'" :value="item.value">{{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>

        <div style="color: #fe8f2d; margin: 15px 0">
          本保单默认附加境内公出附加险条款、就餐时间扩展条款、上下班途中条款
        </div>
      </div>
      <div class="btn_list">
        <a-button class="calBtn_" type="primary" :disabled="disabledAll" @click="countPremiumSum">刷新试算</a-button>
        <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" v-if="!agreementRead" @click="goplicy"
          :disabled="disabledAll">去投保</a-button>
        <!-- <a-button class="calBtn_" type="primary">
          <a href="/files/JYBGZBF/京燕保自选雇主（北分）-速算报价书.xls"
            >速算报价</a
          >
        </a-button> -->
      </div>
    </div>
  </div>
</template>

<script>
  let DATA = require('../data').default;
  import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
  export default {
    mixins: [riskinfoMixin],
    data() {
      return {
        guapre: 12,
        //保障期间
        guarantPre: DATA.guarantPre,
        //投保职业及人数
        occupationNumberList: [
          {
            occupationKind: '1类',
            personNum: 0
          },
          {
            occupationKind: '2类',
            personNum: 0
          },
          {
            occupationKind: '3类',
            personNum: 0
          },
          {
            occupationKind: '4类',
            personNum: 0
          }
        ],
        premiumSum: 0, //总保费

        // 附加24小时意外扩展条款
        XSOptions: [
          {
            value: 0,
            name: '不附加'
          },
          {
            value: 1,
            name: '附加'
          }
        ],
        // 一次性伤残就业补助金
        oneSCOptions: [
          {
            value: 0,
            name: '不附加'
          },
          {
            value: 1,
            name: '附加'
          }
        ],
        // 生活护理费
        SHHLOptions: [
          {
            value: 0,
            name: '不附加'
          },
          {
            value: 1,
            name: '附加'
          }
        ],
        // 工伤伤残赔付高标准（附加提升伤残比例）
        GSDCOptions: [
          {
            value: 0,
            name: '不附加'
          },
          {
            value: 1,
            name: '附加'
          }
        ],

        // 测算要提交的数据
        countData: {
          BZQJa: 12, //保障期间?
          TBZYa: 0, //投保职业?
          SFSGa: 2, //是否涉高?
          SWCJ: 100000, //工伤或意外身故、残疾
          YLFY: 0, //工伤或意外医疗费用（社保范围内0元免赔100%赔付）
          ZFYF: 0, //扩展社保外医疗费用（0元免赔90%赔付）
          ZYJT: 0, //意外住院津贴
          WGFY: 0, //误工费
          YCXSCa: 0, //一次性伤残就业补助金?
          SHHLa: 0, //生活护理费?
          CJBL: 0, //工伤定残高赔付标准
          XS: 0 //附加24小时扩展条款
        },
        //提交data
        data: {
          riskInfos: [],
          salPolicy: {
            productCode: 'jybguzhuzerensf', //产品code
            bracket: 1 //保费期限
          },
          salPolicyHolder: {
            addfifty: '2', // 测算类型
            stature: 2 //是否高空（2-否，1-是）
          },
          premiumBaseDtoList: [] //人数
        },
        planType: 'A'
      };
    },
    props: ['disabledAll'],
    computed: {
      // 扩展社保范围外医疗费用（含甲乙丙类自付和自费）
      ZFYFOptions() {
        let Options = [
          //扩展社保外医疗费用（0元免赔90%赔付）(即保司系统自费药)选择框
          {
            value: 0,
            name: '不附加'
          },
          {
            value: 2000,
            name: '附加'
          }
        ];
        return Options;
      },

      // 工伤事故医疗费用
      YLFYOptions() {
        let option = [
          {
            value: 0,
            name: '不附加',
            disabled: false
          },
          {
            value: 10000,
            name: '1万',
            disabled: false
          },
          {
            value: 20000,
            name: '2万',
            disabled: false
          },
          {
            value: 30000,
            name: '3万',
            disabled: false
          },
          {
            value: 40000,
            name: '4万',
            disabled: false
          },
          {
            value: 50000,
            name: '5万',
            disabled: false
          },
          {
            value: 60000,
            name: '6万',
            disabled: false
          },
          {
            value: 70000,
            name: '7万',
            disabled: false
          },
          {
            value: 80000,
            name: '8万',
            disabled: false
          },
          {
            value: 90000,
            name: '9万',
            disabled: false
          },
          {
            value: 100000,
            name: '10万',
            disabled: false
          }
        ];

        let occlen = this.occupationNumberList.length;
        if (this.occupationNumberList[occlen - 1].personNum || this.countData.SFSGa == '1') {
          return option.filter(item => item.value <= this.countData.SWCJ * 0.1);
        } else {
          return option.filter(item => item.value <= this.countData.SWCJ * 0.2);
        }
      },
      // 工伤身故、残疾
      SWCJOptions() {
        let SWCJOptions = [
          {
            value: 100000,
            name: '10万'
          },
          {
            value: 200000,
            name: '20万'
          },
          {
            value: 300000,
            name: '30万'
          },
          {
            value: 400000,
            name: '40万'
          },
          {
            value: 500000,
            name: '50万'
          },
          {
            value: 600000,
            name: '60万'
          },
          {
            value: 700000,
            name: '70万'
          },
          {
            value: 800000,
            name: '80万'
          },
          {
            value: 900000,
            name: '90万'
          },
          {
            value: 1000000,
            name: '100万'
          }
        ];
        let occlen = this.occupationNumberList.length;
        if (this.countData.SFSGa == 1) {
          return SWCJOptions.filter(item => item.value <= 500000);
        } else {
          if (this.occupationNumberList[occlen - 1].personNum) {
            this.countData.SWCJ = 100000;
            return SWCJOptions.filter(item => item.value <= 600000);
          } else {
            return SWCJOptions;
          }
        }
      },
      // 意外住院津贴每次事故
      ZYJTOptions() {
        let ZYJTOptions = [
          //意外住院津贴责任 : ZYJT
          {
            value: 0,
            name: '不附加'
          },
          {
            value: 50,
            name: '50元/天'
          },
          {
            value: 100,
            name: '100元/天'
          },
          {
            value: 150,
            name: '150元/天'
          },
          {
            value: 200,
            name: '200元/天'
          }
        ];
        let occlen = this.occupationNumberList.length;
        if (this.occupationNumberList[occlen - 1].personNum) {
          return ZYJTOptions.filter(item => item.value <= 100);
        }
        return ZYJTOptions;
      },

      // 误工费
      WGFYOptions() {
        let WGFYOptions = [
          {
            value: 0,
            name: '不附加'
          },
          {
            value: 50,
            name: '50元/天'
          },
          {
            value: 100,
            name: '100元/天'
          },
          {
            value: 150,
            name: '150元/天'
          },
          {
            value: 200,
            name: '200元/天'
          }
        ];
        let occlen = this.occupationNumberList.length;
        if (this.occupationNumberList[occlen - 1].personNum) {
          return WGFYOptions.filter(item => item.value <= 100);
        }
        return WGFYOptions;
      },
      // 总数量
      totalNumber() {
        let num = 0;
        this.occupationNumberList.forEach(e => {
          num += Number(e.personNum);
        });
        return num;
      },
      // 险种的数组
      riskInfos() {
        let infos = [
          {
            riskCode: 'GSSGCJ', //工伤身故、残疾
            amount: this.countData.SWCJ,
            premiumAmt: 0,
            riskName: `工伤身故、残疾`,
            riskAmountDesc: this.countData.SWCJ
          },
          {
            riskCode: 'GSSGYL', //工伤事故医疗费用
            amount: this.countData.YLFY,
            premiumAmt: 0,
            riskName: `工伤或意外医疗费用（社保范围内0元免赔100%赔付）`,
            riskAmountDesc: this.countData.YLFY
          },
          {
            riskCode: 'TZSBFWW', //扩展社保外医疗费用（0元免赔90%赔付）
            amount: this.countData.ZFYF,
            premiumAmt: 0,
            riskName: `扩展社保外医疗费用（0元免赔90%赔付）`,
            riskAmountDesc: this.countData.ZFYF
          },
          {
            riskCode: 'YWZYJTMC', //意外住院津贴每次事故
            amount: this.countData.ZYJT,
            premiumAmt: 0,
            riskName: `意外住院津贴`,
            riskAmountDesc: `${this.countData.ZYJT}元/天`
          },
          {
            riskCode: 'WGF', //误工费
            amount: this.countData.WGFY,
            premiumAmt: 0,
            riskName: `误工费`,
            riskAmountDesc: `${this.countData.WGFY}元/天`
          },
          {
            riskCode: 'YCXSCJY', //一次性伤残就业补助金
            amount: this.countData.YCXSCa,
            premiumAmt: 0,
            riskName: `一次性伤残就业补助金`,
            riskAmountDesc: this.countData.YCXSCa ? '附加' : '不附加'
          },
          {
            riskCode: 'SHHLF', //生活护理费
            amount: this.countData.SHHLa,
            premiumAmt: 0,
            riskName: `生活护理费`,
            riskAmountDesc: this.countData.SHHLa ? '附加' : '不附加'
          },
          {
            riskCode: 'GSDCGPF', //工伤定残高赔付标准
            amount: this.countData.CJBL,
            premiumAmt: 0,
            riskName: `工伤定残高赔付标准`,
            riskAmountDesc: this.countData.CJBL ? '附加' : '不附加'
          },
          {
            riskCode: '24HYWXTB', //24小时意外险特别扩展条款
            amount: this.countData.XS,
            premiumAmt: 0,
            riskName: `24小时意外险特别扩展条款`,
            riskAmountDesc: this.countData.XS ? '附加' : '不附加'
          }
        ];
        return infos;
      }
    },
    watch: {
      'countData.YLFY'(val) {
        if (!val) {
          this.countData.ZFYF = 0;
        }
      }
    },
    mounted() {
      this.$bus.$on('busRiskInfos', data => {
        let obj = this.$lodash.cloneDeep(this.countData);
        data.forEach(e => {
          if (e.riskCode == 'GSSGCJ') obj.SWCJ = e.amount;
          if (e.riskCode == 'GSSGYL') obj.YLFY = e.amount;
          if (e.riskCode == 'TZSBFWW') obj.ZFYF = e.amount;
          if (e.riskCode == 'YWZYJTMC') obj.ZYJT = e.amount;
          if (e.riskCode == 'WGF') obj.WGFY = e.amount;
          if (e.riskCode == 'YCXSCJY') obj.YCXSCa = e.amount;
          if (e.riskCode == 'SHHLF') obj.SHHLa = e.amount;
          if (e.riskCode == 'GSDCGPF') obj.CJBL = e.amount;
          if (e.riskCode == '24HYWXTB') obj.XS = e.amount;
        });
        this.countData = { ...obj };
        if(data.salPolicyExt && data.salPolicyExt.isworkheightinvolved) {
          this.countData.SFSGa = Number(data.salPolicyExt.isworkheightinvolved)
        } else {
          this.countData.SFSGa = 2
        }
        console.log(this.countData);
        this.changeData();
      });
      this.$bus.$on('onbracket', data => {
        this.guapre = data;
      });
    },
    beforeDestroy() {
      this.$bus.$off('busRiskInfos');
    },
    methods: {
      // 改变试算的数据
      changeData(value, param) {
        console.log(value, param);
        this.countData[param] = value;
        this.data = {
          riskInfos: this.riskInfos,
          salPolicy: {
            productCode: 'jybguzhuzerensf', //产品code
            bracket: this.countData.BZQJa.toString() //保费期限
          },
          salPolicyHolder: {
            addfifty: '2', // 测算类型
            stature: this.countData.SFSGa.toString() //是否高空（2-否，1-是）
          },
          salPolicyExt: {
            isworkheightinvolved: this.countData.SFSGa.toString(),
            architecture: ''
          },
          premiumBaseDtoList: this.occupationNumberList //人数
        };
        console.log(this.data, '开始传数据');
        let arrData = JSON.parse(JSON.stringify(this.data));
        arrData['premiumBaseDtoList'] = [];
        this.$bus.$emit('onRiskInfos', arrData);
      },
      //试算的接口
      resultPremiumSum(data) {
        this.$api.calPremiumEmployer(data).then(res => {
          // console.log(res, "测试保费");
          if (res.data.success) {
            let data = res.data.content;
            console.log(data);
            this.premiumSum = this.cesuannum(data);
            console.log(data);
            console.log(this.premiumSum);
            this.$bus.$emit('resultPcontent', data);
          } else {
            this.$message.error(res.data.returnMsg + '错误');
          }
        });
      },
      //测算的总价格
      cesuannum(data) {
        var a = {};
        var resultnum = 0;
        this.data.premiumBaseDtoList.forEach(e => {
          a[e.occupationKind] = e.personNum;
        });
        for (const key in a) {
          console.log(key);
          resultnum += a[key] * data[key];
        }
        return resultnum.toFixed(2);
      },
      //刷新试算 2
      countPremiumSum() {
        this.data.salPolicyHolder.addfifty = '2';
        if (!this.totalNumber) {
          this.premiumSum = 0;
          this.$message.warning('请选择投保人数');
          return;
        }
        this.resultPremiumSum(this.data);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .policy {
    display: none;
  }

  .calTxt_ {
    font-size: 18px !important;
    font-weight: bold !important;
    color: #666666;
  }

  .pre-box {
    margin-top: 15px;
  }

  .form_items {
    display: flex;
    width: 100%;
    color: #333;
    margin-bottom: 10px;
  }

  .risk_ {
    width: 60%;
  }

  .btn_list {
    margin-top: 20px;
    display: flex;

    .calBtn_ {
      margin-right: 30px;
    }
  }

  .flex_ {
    display: flex;
    flex-wrap: wrap;
  }

  .form_item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #333;
    margin-bottom: 10px;

    &.width_50 {
      width: 50%;
    }

    &.width_40 {
      width: 40%;
    }

    &.width_60 {
      width: 60%;
    }

    >label {
      white-space: nowrap;
      margin-right: 10px;
      margin-top: 15px;
    }

    .right_ {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;

      .select_ {
        margin-top: 10px;
      }

      .check_item {
        display: flex;
        align-items: center;
        margin-right: 10px;
        margin-top: 10px;

        &.on {
          label {
            border-color: #fe8f2d;
          }
        }

        label {
          border: 1px solid #d9d9d9;
          padding: 3px 10px;
          border-radius: 3px;
          margin-right: 5px;
        }

        &.s_input input {
          width: 50px;
        }

        input {
          width: 150px;
          margin-right: 5px;
        }
      }
    }
  }
</style>